import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateDetachedGarageCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const propertyIdentificationForTransaction = propertyIdentification[id];

  if (!improvementsForTransaction || !propertyIdentificationForTransaction) {
    return undefined;
  }

  const {
    detachedGarage,
    craftsmanQuality: quality,
    propertyType = 'singleFamilyResidence',
  } = improvementsForTransaction;

  if (!detachedGarage || !ORDER_FEATURES.detachedGarage.hasFeature(improvementsForTransaction))
    return undefined;
  const {
    address: { PostalCode: zipCode },
  } = propertyIdentificationForTransaction;

  if (isUndefined(quality) || (quality * 10) % 1 !== 0 || quality < 1 || isUndefined(zipCode)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getGarageCost({
    sqft: AloftArea.schema.parse(detachedGarage.area),
    garageType: 'detached',
    zipCode,
    quality: detachedGarage.quality ?? quality,
    propertyType,
  });
};

export const {
  selectDetachedGarageCost,
  selectZipOnlyDetachedGarageCost,
  selectDetachedGarageCosts,
  selectDetachedGarageCostDisplay,
} = createFeatureCostSelectors({
  calculate: calculateDetachedGarageCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectDetachedGarageCost',
    zipOnly: 'selectZipOnlyDetachedGarageCost',
    costs: 'selectDetachedGarageCosts',
    display: 'selectDetachedGarageCostDisplay',
  },
});
